<template>
  <div id="application_review_outer" v-if="user != null">
    <div class="review-doing" v-if="code == 0">
      您的会员材料正在审核中，预计5个工作日内完成审核。
    </div>
    <div class="review-done" v-else>
      <div class="notice-label">{{displayError}}</div>

      <el-button v-if="code == 1" round @click="nextButtonClicked">下一步</el-button>
      <el-button v-else-if="code == 2" round @click="backToEditPage">返回修改</el-button>
      <el-button v-else-if="code == 3" round @click="disableButtonClicked">我已知晓</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupApplicationReviewing",
  props: [
    'status'
  ],
  data() {
    return {
      currentStatus: null,
      code: 0, // 0 进行中, 1 成功, 2 失败, 3 不符合条件
      myErrorStr: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },

    displayError() {
      if (this.myErrorStr != null && this.myErrorStr.length > 0) {
        return this.myErrorStr;
      } else {
        return this.errorMessage;
      }
    },

    errorMessage() {
      switch (this.code) {
        case 1:
          return '您的会员材料已审核通过，请完成会员费支付！';
          break;
        case 2:
          return '您的***资料填写错误，请重新修改后提交';
          break;
        case 3:
          return '经审核，贵机构不符合本协会的入会条件，感谢您的支持与参与。如有异议，可通过\“上海市篮球协会\”官方微信公众号，与我们联系。';
          break;
        default:
          return null;
      }
    },
    httpManager() {
      return this.$store.state.http;
    }
  },
  watch: {
    status(val) {
      this.currentStatus = val;
    }
  },
  mounted() {
    this.currentStatus = this.status;
    let user = this.user;
    let auditRemark = user.auditRemark;
    if (auditRemark != null && auditRemark.length > 0) {
      this.myErrorStr = auditRemark.removeBlanks();
    }

    if (this.currentStatus == 1) { // 审核中
      this.code = 0;
    } else if (this.currentStatus == 2) {
      this.code = 1;
    } else if (this.currentStatus == 4) {
      this.code = 2;
    } else if (this.currentStatus == 7) {
      this.code = 3;
    }
  },
  methods: {
    updateModifiedValue(modified, callback) {
      let user = this.user;
      if (user == null) {
        return;
      }
      let params = {};
      params.id = user.id;
      params.modified = modified;

      this.httpManager.ajax.postUserModifiedChangeRequest(params, function (data) {
        let code = data.code;
        if (code == 0) {
          callback();
          return;
        }
        _this.$toast('更新失败！');
      }, function (data) {
        _this.$toast('更新失败，请重试！');
      });
    },

    updateStatus(status, callback) {
      let user = this.user;
      if (user == null) {
        return;
      }
      let params = {};
      params.id = user.id;
      params.status = status;

      let _this = this;
      this.httpManager.ajax.postUserUpdateStatusRequest(params, function (data) {
        let code = data.code;
        if (code == 0) {
          callback();
          return;
        }
        _this.$toast('更新失败！');
      }, function (data) {
        _this.$toast('更新失败，请重试！');
      });
    },

    updateAuditStatus(status, callback) {
      let user = this.user;
      if (user == null) {
        return;
      }
      let params = {};
      params.id = user.id;
      params.auditStatus = status;
      let _this = this;
      this.httpManager.ajax.postUpdateUserAuditStatusRequest(params, function (data) {
        let code = data.code;
        if (code == 0) {
          callback();
          return;
        }
        _this.$toast('更新失败！');
      }, function (data) {
        _this.$toast('更新失败，请重试！');
      });
    },

    nextButtonClicked() {
      let _this = this;
      this.updateStatus(9, function() {
        _this.updateModifiedValue(0, function() {
          _this.$emit('nextClick');
        });
      });
    },
    backToEditPage() {
      this.$emit('errorClick');
    },
    disableButtonClicked() {
      let _this = this;
      this.updateAuditStatus(0, function() {
        _this.updateModifiedValue(0, function() {
          _this.$emit('forbidClick');
        });
      });
    }
  }
}
</script>

<style scoped>
  #application_review_outer {
    padding: 30px 5px;
    width: 100%;
  }

  #application_review_outer .review-done .el-button {
    background-color: #fc1a34;
    border-color: #fc1a34;
    width:80%;
    max-width: 200px;
    padding-left: 0;
    padding-right: 0;
    color: white;
  }

  #application_review_outer .review-doing {
    height: 150px;
    line-height: 150px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 1rem;
    text-align: center;
  }
  #application_review_outer .review-done {
    padding-top: 20px;
    height: 150px;
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  #application_review_outer .review-done .notice-label {
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/group/groupApplicationVues/GroupApplicationReviewing.vue